var exports = {
  "lG": "Dialog__VZcVr2",
  "MI": "Dialog_Body__oZxM-R",
  "az": "Box__sQRVFR",
};

module.exports = exports;
